import { render, staticRenderFns } from "./QuestionRenderer.vue?vue&type=template&id=296c366c&scoped=true"
import script from "./QuestionRenderer.vue?vue&type=script&lang=js"
export * from "./QuestionRenderer.vue?vue&type=script&lang=js"
import style0 from "./QuestionRenderer.vue?vue&type=style&index=0&id=296c366c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c366c",
  null
  
)

export default component.exports